import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Lock } from 'lucide-react';
export const ClassifiedProject = () => {
  return <section className="relative bg-base-black py-20 border-y border-dark-3 overflow-hidden" data-id="element-41" data-mp="wh2apr34qpd1">
      {/* Background grid + accent lines */}
      <div className="absolute inset-0 bg-tactical-grid opacity-[0.08] pointer-events-none" data-id="element-42" data-mp="mid2yr4y6lai"></div>
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-acid-green/40 to-transparent" data-id="element-43" data-mp="ig9dgylg1g68"></div>
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-acid-green/40 to-transparent" data-id="element-44" data-mp="dorn14h1qxzi"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-45" data-mp="8olt1hnb0ze9">
        <div className="max-w-5xl mx-auto" data-id="element-46" data-mp="3sy1ivlcnu5l">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border border-acid-green/30 bg-base-black relative overflow-hidden grid grid-cols-1 md:grid-cols-2" data-id="element-47" data-mp="3uxwspg6etlkt">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-48" data-mp="2j0ulsx64wba1"></div>
            <div className="absolute top-0 right-0 w-5 h-5 border-t-2 border-r-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-49" data-mp="2nzpbmj2ir03n"></div>
            <div className="absolute bottom-0 left-0 w-5 h-5 border-b-2 border-l-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-50" data-mp="3gntl7fo7nxbm"></div>
            <div className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-51" data-mp="32ou02hzwq0k7"></div>

            {/* Scanline accent on top */}
            <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-acid-green to-transparent z-20 pointer-events-none" data-id="element-52" data-mp="1r8dpb1zas83o"></div>

            {/* LEFT: Text Content */}
            <div className="relative z-10 bg-dark-1 p-8 md:p-12 flex items-center order-2 md:order-1" data-id="element-53" data-mp="1sb4hnncvhkl">
              <div data-id="element-54" data-mp="3sxjb51vu3xr9">
                <div className="flex items-center gap-4 mb-5" data-id="element-55" data-mp="3sz46uutvxmqp">
                  <div className="shrink-0 w-12 h-12 rounded-full border border-acid-green/40 bg-acid-green/10 flex items-center justify-center text-acid-green relative" data-id="element-56" data-mp="3o72wxfk6w83u">
                    <ShieldAlert size={22} data-id="element-57" data-mp="3j66s8zs0khxd" />
                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-base-black rounded-full flex items-center justify-center" data-id="element-58" data-mp="3f6xz9x4sso2v">
                      <Lock size={9} className="text-text-dimmed" data-id="element-59" data-mp="3a608wx9mwnqa" />
                    </div>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-60" data-mp="35akvg6fjgtue">
                    <span className="w-2 h-2 bg-acid-green animate-pulse" data-id="element-61" data-mp="30agnx5wlz9gb"></span>
                    <span className="font-barlow font-bold text-[10px] text-acid-green tracking-[4px] uppercase" data-id="element-62" data-mp="13hn82q4j6tgu">
                      CLASSIFIED INTEL — LEVEL 4
                    </span>
                  </div>
                </div>

                <h3 className="font-bebas text-3xl md:text-4xl text-white tracking-wide mb-4" data-id="element-63" data-mp="16yjdo0hup4br">
                  ACTIVE U.S. GOVERNMENT CONTRACT
                </h3>
                <p className="font-inter text-sm md:text-base text-text-body leading-relaxed mb-4" data-id="element-64" data-mp="1fr34ierwi4m1">
                  We're currently building a second, restricted-issue mask —
                  engineered exclusively for U.S. government and military use
                  under an active federal contract. That unit will never be
                  available to the public.
                </p>
                <p className="font-inter text-sm md:text-base text-white leading-relaxed font-medium" data-id="element-65" data-mp="x0by9m37mubv">
                  The mask you can buy today is our civilian flagship — the same
                  DNA, the same obsession, the same{' '}
                  <span className="text-acid-green" data-id="element-66" data-mp="28fikp4mrqsyy">PATENT PENDING</span>{' '}
                  engineering.
                </p>

                {/* Patent Pending Badge */}
                <div className="mt-5 inline-flex items-center gap-2 border border-acid-green/40 bg-acid-green/5 px-3 py-1.5" data-id="element-67" data-mp="3md3awwvtmhgy">
                  <span className="w-1 h-1 bg-acid-green animate-pulse" data-id="element-68" data-mp="3hete6hug78t8"></span>
                  <span className="font-barlow font-bold text-[10px] text-acid-green tracking-[3px] uppercase" data-id="element-69" data-mp="3vdjc1zp3dcin">
                    U.S. PATENT PENDING
                  </span>
                </div>
              </div>
            </div>

            {/* RIGHT: Image Panel — Fully visible */}
            <div className="relative min-h-[320px] md:min-h-[480px] order-1 md:order-2 overflow-hidden" data-id="element-70" data-mp="45dvj4rkxbum">
              <img src="https://cdn.magicpatterns.com/uploads/1VfFbzeG6PLWskxprS5dbU/hf_20260519_142822_5efe37ff-2148-46ab-b7c6-85a4e80d80c1.png" alt="Classified Project — Operator with mask in tactical command center" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-71" data-mp="hwsgvi8ylp4u" />

              {/* "LIVE FEED" indicator overlay */}
              <div className="absolute top-4 right-4 z-10 flex items-center gap-2 bg-base-black/70 backdrop-blur-sm border border-acid-green/30 px-2.5 py-1" data-id="element-72" data-mp="16k1h8lmtj4sx">
                <span className="w-1.5 h-1.5 bg-acid-green animate-pulse rounded-full" data-id="element-73" data-mp="wksp7ybik097"></span>
                <span className="font-barlow font-bold text-[9px] text-acid-green tracking-[3px] uppercase" data-id="element-74" data-mp="11jdgv9cp9bm1">
                  LIVE FEED
                </span>
              </div>

              {/* Bottom location stamp */}
              <div className="absolute bottom-4 left-4 z-10 bg-base-black/70 backdrop-blur-sm border border-dark-3 px-2.5 py-1" data-id="element-75" data-mp="sj74jqsqmhog">
                <span className="font-barlow font-bold text-[9px] text-white/80 tracking-[2px] uppercase" data-id="element-76" data-mp="dvm64a6t56mv">
                  ● TACTICAL OPS · CLASSIFIED LOCATION
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};